import axios from 'axios';

const loadAbort = () => {
  return new AbortController();
};

export const commissionDetailPreviewEndpoint = (
  query: string,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}/ts/v1/admin/commission-detail/preview?${query}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};
